<template>
  <SelectItem
    class="group flex items-center p-3 md:py-2 gap-2 shrink-0 bg-primary border border-secondary rounded-md focus:ring-brand focus-within:ring-brand focus-visible:outline-none data-[state=checked]:bg-brand-primary_alt data-[state=checked]:border-brand data-[state=checked]:text-brand-secondary cursor-pointer"
  >
    <Indicator
      variant="building"
      mode="transparent"
      size="xs"
      :imageUrl="item?.imageUrl"
    />
    <SelectItemText>
      {{ item.name }}
    </SelectItemText>
    <Id
      v-if="item.identifier"
      :size="maxTablet ? 'md' : 'sm'"
      :label="item.identifier"
      class="group-data-[state=checked]:bg-brand-primary group-data-[state=checked]:border-transparent group-data-[state=checked]:text-brand-secondary group-data-[state=checked]:[&>span]:!text-brand-secondary"
    />
  </SelectItem>
</template>

<script setup>
import { SelectItem, SelectItemText } from "radix-vue";
import { Id } from "@/SharedComponents/Badges";
import { Indicator } from "@/SharedComponents/Indicator";
import { useBreakpoints } from "@/Composables/useBreakpoints";

const { maxTablet } = useBreakpoints();

defineProps({
  item: { type: Object, required: false },
});
</script>
